/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolEnergySavingsLeafIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-energy-savings-leaf"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.63 17.1L16.05 12.25Q16.32 12 16.2 11.68Q16.07 11.35 15.72 11.3L11.5 10.88L14.03 7.4Q14.13 7.28 14.13 7.13Q14.13 6.97 14 6.85Q13.88 6.72 13.71 6.72Q13.55 6.72 13.43 6.85L8 11.7Q7.72 11.93 7.84 12.25Q7.95 12.57 8.3 12.63L12.57 13.05L10 16.55Q9.9 16.68 9.91 16.82Q9.93 16.98 10.05 17.1Q10.18 17.23 10.34 17.23Q10.5 17.23 10.63 17.1ZM12.03 20.8Q10.55 20.8 9.24 20.34Q7.92 19.88 6.8 19.07L5.45 20.43Q5.25 20.63 5.03 20.71Q4.8 20.8 4.53 20.8Q3.98 20.8 3.59 20.41Q3.2 20.02 3.2 19.48Q3.2 19.2 3.3 18.96Q3.4 18.73 3.6 18.52L4.92 17.2Q4.13 16.07 3.66 14.76Q3.2 13.45 3.2 11.97Q3.2 8.32 5.78 5.76Q8.35 3.2 12.03 3.2L18.15 3.2Q19.27 3.2 20.04 3.96Q20.8 4.72 20.8 5.85L20.8 11.97Q20.8 15.65 18.24 18.23Q15.68 20.8 12.03 20.8Z" fill={color} />
    </svg>
  );
}
